import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { Clock } from "lucide-react";
import Layout from "@/components/Layout";

interface Props {
  titulo: string;
  descripcion: string;
  path: string;
}

export default function Proximamente({ titulo, descripcion, path }: Props) {
  return (
    <Layout>
      <Helmet>
        <title>{titulo} | Sercom</title>
        <meta name="description" content={descripcion} />
        <link rel="canonical" href={`https://sercomcs.com${path}`} />
      </Helmet>
      <div className="pt-28 pb-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 min-h-[70vh] flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center max-w-xl"
        >
          <div className="w-20 h-20 rounded-full bg-accent/10 text-accent flex items-center justify-center mx-auto mb-6">
            <Clock className="w-10 h-10" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">{titulo}</h1>
          <p className="text-lg text-muted-foreground mb-6">Próximamente</p>
          <p className="text-muted-foreground">{descripcion}</p>
        </motion.div>
      </div>
    </Layout>
  );
}
